export const redirectTo = (url: string) => {
  window.location.assign(url);
};
